<template>
  <div>
    <!-- <v-navigation-drawer v-model="modal" width="400" app temporary right class="wost-drawer" >
        
            <div class="d-block text-center">
                <h3>Ingresar la empresa</h3>
            </div>
           
                <v-row class="pl-3 pr-3">
                    <v-col cols="11" class="pb-4" v-if="client == null">
                        <v-autocomplete                             
                            :value="client_id"
                            :items="clients"
                            label="Empresa"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                            @change="handleSelectClient"
                            :filter="customFilter"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                    <v-list-item-subtitle>
                                       RUC: {{ data.item.ruc }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="1" class="pl-0" v-if="client == null">
                        <v-icon color="success" class="mt-2"
                            @click="handleViewCreateCompany">
                            fas fa-plus-circle
                        </v-icon>
                    </v-col>
                </v-row>
                <v-row class="pl-3 pr-3" v-if="client">
                    <v-col cols="12" class="pt-0 pb-0">
                        <v-list two-line class="pt-0 pb-0">
                            <v-list-item class="pl-1 pr-1">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-icon color="green" class="mr-2" size="18">
                                            fas fa-user-tag
                                        </v-icon>
                                        <span class="text-uppercase font-weight-bold cart-label-customer">{{ client.name }}</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <span class="ml-8"> RUC: {{ client.ruc }} </span>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon @click="handleClearClient" color="red">
                                        <v-icon>far fa-times-circle</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        
                    </v-col>                    
                </v-row>

            <v-row justify="center">
                    <v-row class="pl-3 pr-3">
                        <v-col cols="6" class="pt-0 pl-6">
                            <v-btn block dark color="red" height="45" @click="closeModal">
                                CANCELAR
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pt-0 pr-6">
                            <v-btn block dark color="green" height="45" @click="saveModal">
                                GUARDAR 
                            </v-btn>
                        </v-col>
                    </v-row>
            </v-row>

        </v-navigation-drawer> -->
    <v-dialog
      v-model="modal"
      width="550"
      hide-overlay
      transition="fab-transition"
    >
      <template> </template>
      <v-card>
        <v-card-title>
          <span class="text-h5"> <h3>Ingresar la empresa</h3></span>
        </v-card-title>
        <v-card-text>
          <v-row class="pl-3 pr-3">
            <v-col cols="11" class="pb-4" v-if="client == null">
              <v-autocomplete
                :value="client_id"
                :items="clients"
                label="Empresa"
                hide-details
                outlined
                :item-text="customText"
                item-value="id"
                clearable
                @change="handleSelectClient"
                :filter="customFilter"
                :loading="loading"
                v-on:keyup.enter="searchClient($event)"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      RUC: {{ data.item.ruc }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="pl-0" v-if="client == null">
              <v-icon
                color="success"
                class="mt-2"
                @click="handleViewCreateCompany"
              >
                fas fa-plus-circle
              </v-icon>
            </v-col>
          </v-row>
          <v-row class="pl-3 pr-3" v-if="client">
            <v-col cols="12" class="pt-0 pb-0">
              <v-list two-line class="pt-0 pb-0">
                <v-list-item class="pl-1 pr-1">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon color="green" class="mr-2" size="18">
                        fas fa-user-tag
                      </v-icon>
                      <span
                        class="text-uppercase font-weight-bold cart-label-customer"
                        >{{ client.name }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="ml-8"> RUC: {{ client.ruc }} </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="handleClearClient" color="red">
                      <v-icon>far fa-times-circle</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-container class="pt-0 pb-0">
            <v-row>
              <v-col cols="6">
                <v-btn dark color="red" block @click="closeModal">
                  Cancelar
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn dark color="green" block @click="saveModal">
                  Aceptar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <!-- <v-card-actions>
           <v-row justify="center">
                    <v-row class="pl-10 pr-10">
                        <v-col cols="6" class="pt-0 pl-8">
                            <v-btn block dark color="red" height="45" @click="closeModal">
                                CANCELAR
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pt-0 pr-8">
                            <v-btn block dark color="green" height="45" @click="saveModal">
                                GUARDAR 
                            </v-btn>
                        </v-col>
                    </v-row>
            </v-row>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <create-update-company ref="CreateUpdateCompany"></create-update-company>
  </div>
</template>
<script>
import CreateUpdateCompany from "../../components/client/CreateUpdate";
import ArrayTools from "../../helpers/ArrayTools";
import { mapState, mapActions } from "vuex";
export default {
  name: "Client",
  components: {
    CreateUpdateCompany,
  },
  props: { reciveEmpresa: Function },
  mounted() {
    this.getClients();
    // console.log(this.reciveEmpresa({}));
  },
  data() {
    return {
      name: null,
      modal: false,
      select_client_aux: null,
      loading: false,
    };
  },
  computed: {
    ...mapState("clients", ["clients"]),
    ...mapState("sales", ["client", "client_id"]),
  },
  methods: {
    ...mapActions("sales", [
      "select_client",
      "select_is_client",
      "select_document_active",
    ]),
    ...mapActions("clients", ["getClients"]),
    customText(item) {
      let text = item.fullname;

      return text;
    },
    customFilter(item, queryText, itemText) {
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    showForm(params) {
      this.modal = !this.modal;
      if (this.client) {
        if (this.select_client_aux == null) {
          this.select_client_aux = this.client;
        }
      }
    },
    probar() {
      this.reciveEmpresa({ name: this.name });
    },

    closeModal() {
      if (this.select_client_aux) {
        this.select_client(this.select_client_aux);
        this.select_is_client(true);
      } else {
        this.reciveEmpresa(null);
        this.select_document_active("TICKET");
        this.handleClearClient();
      }
      this.select_client_aux = null;
      this.modal = !this.modal;
    },
    saveModal() {
      if (this.client != null) {
        this.reciveEmpresa(this.client);
      } else {
        this.reciveEmpresa(null);
        this.select_document_active("TICKET");
        this.handleClearClient();
      }
      this.select_client_aux = null;
      this.modal = !this.modal;
    },
    handleSelectClient(value) {
      if (value == null || value == undefined) {
        this.select_client(null);
      } else {
        let selected_client = ArrayTools.getElementById(this.clients, value);
        this.select_client(selected_client);
        this.select_is_client(true);
      }
    },
    handleClearClient() {
      this.select_client(null);
      this.select_is_client(null);
    },
    handleViewCreateCompany() {
      this.$refs.CreateUpdateCompany.showForm("Nueva Empresa", "create");
    },
    async searchClient(event) {
      this.loading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getClients({ name: value });
      } else {
        await this.getClients();
      }
      this.loading = false;
    },
  },
};
</script>
